import { createTestIds } from '../../utils';

export const getPreviewPanelTestIds = createTestIds('preview-panel', [
  'close',
  'progress'
] as const);
